import type { WheelEvent } from 'react';

/**
 * While someone is typing into a number field, a stray mouse-wheel tick must not
 * nudge the value up or down. Blur the input on wheel so the scroll does nothing
 * to it — the operator clicks back in and keeps typing.
 *
 * Attach as `onWheel={stopWheelNudge}` on a `<TextField type="number">` (or any
 * wrapper): the wheel event bubbles from the inner `<input>`, so `e.target` is
 * the input itself. A global fallback also lives in App.tsx; this makes the
 * behaviour explicit on the fields where an accidental change actually costs
 * money (prices, amounts, discounts).
 */
export const stopWheelNudge = (e: WheelEvent<HTMLElement>) => {
  const el = e.target as HTMLElement;
  if (el instanceof HTMLInputElement && el.type === 'number') {
    el.blur();
  }
};
